import { NgModule } from '@angular/core';
import { AgGridFitWidthDirective } from './ag-grid-fit-width.directive';
import { AgGridExtendLastColumnDirective } from './ag-grid-extend-last-column.directive';
import { AgGridAutoFitWidthDirective } from './ag-grid-auto-fit-width.directive';
import { AgGridCommonStylesDirective } from './ag-grid-common-styles.directive';

@NgModule({
  declarations: [
    AgGridFitWidthDirective,
    AgGridExtendLastColumnDirective,
    AgGridAutoFitWidthDirective,
    AgGridCommonStylesDirective,
  ],
  exports: [
    AgGridFitWidthDirective,
    AgGridExtendLastColumnDirective,
    AgGridAutoFitWidthDirective,
    AgGridCommonStylesDirective,
  ],
  imports: [],
})
export class AgGridDirectivesModule { }
